import sample from './sample.js';

// Shuffle a collection.
export default function shuffle(obj) {
  return sample(obj, Infinity);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/shuffle.js
// module id = 328
// module chunks = 0 1